import React, { useContext, useEffect } from "react";
import { AuthContext } from "../context/Authcontext";
import { formatINR } from "../utils/money";
import "../assets/matka/css/matka.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const MatkaPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, userBalnc, userdata } = useContext(AuthContext);
  // This page has no site header, and the header is what normally loads the
  // balance -- opened directly, it showed ₹0. Load it here.
  useEffect(() => {
    if (isAuthenticated) userdata(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
  // The board below is a layout only -- nothing here places a bet yet. The
  // balance used to be a hard-coded "₹10000", shown even to logged-out
  // visitors, which read as a real (and free) wallet.
  const balance = Math.max(0, Number(userBalnc?.userTotalBal) || 0);
  return (
    <>
      <div className="ticket-container">
        <div className="header">
          <span className="title" onClick={() => navigate(-1)}>
            <ArrowLeft /> {/* back icon */} Back
          </span>
          {isAuthenticated ? (
            <span className="money">{formatINR(balance)}</span>
          ) : null}
        </div>

        <p className="matka-soon" role="status">
          Matka is coming soon. You can browse the board, but bets can't be
          placed yet.
        </p>

        <div className="icons-row">
          {[...Array(100)].map((_, i) => (
            <div key={i} className="icon num">
              {i + 1}
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="bottom-section">
          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">10</span>
          </div>

          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">100</span>
          </div>

          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">500</span>
          </div>

          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">1K</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default MatkaPage;
